import { useQuery } from "@tanstack/react-query";
import { CatalogService } from "@/services/catalog/catalog-service";
import type { CatalogItemsParams, AmazonianHardwareWithTaxonomyID } from "@/services/catalog/catalog.types";

const catalogService = new CatalogService();

export type { CatalogItemsParams };

export function useHardwareCatalog(params: CatalogItemsParams | undefined) {
  const { data, error, isLoading } = useQuery({
    queryKey: ["catalog-items", params],
    queryFn: () => catalogService.getItems(params!),
    enabled: !!params,
  });

  return {
    data: data?.data,
    paginationInfo: data?.pagination ?? { total: 0, offset: 0, limit: 0 },
    error: error ?? undefined,
    isLoading,
  };
}
